import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MoreHoriz } from '@tempo-io/sui-icons';
import { useSwimlaneRootProps } from '@/components/ui/swimlane/context';
import { COLUMN_HEADER_HEIGHT } from '@/components/ui/swimlane/layout/constants';
import { HeaderCell } from '../HeaderCell';
import { SwimlaneHeaderMenu } from '../menu/SwimlaneHeaderMenu';
import type { IHeaderProps } from '../types';

export type ColumnHeaderProps = IHeaderProps & React.HTMLAttributes<HTMLDivElement>;

// Consider refactoring the SL and headers to properly pass the config instead of requiring the consumer to redefine this component
export function ColumnHeader({
  backgroundColor = 'transparent',
  labelColor = 'inherit',
  children = '',
  onOpenCard,
  hideHeader,
  openCardLabel = '',
  hideHeaderTooltip,
  reorderDisabledTooltip,
  isReOrderingDisabled = false,
  isViewCardOptionDisabled = false,
  ...containerProps
}: ColumnHeaderProps) {
  const { isPublicationMode, isHeaderMenuDisabled } = useSwimlaneRootProps();

  // Backwards compatibility: if isHeaderMenuDisabled is not passed, only use isPublicationMode
  const shouldHideMenu = isHeaderMenuDisabled !== undefined ? isHeaderMenuDisabled : false;

  return (
    <ColumnHeaderCell
      role="columnheader"
      $backgroundColor={backgroundColor}
      $labelColor={labelColor}
      {...containerProps}
    >
      <Tooltip title={typeof children === 'string' ? children : ''} placement="bottom">
        <ColumnHeaderText className="fs-exclude" data-dd-action-name="swimlane label - redacted">
          {children}
        </ColumnHeaderText>
      </Tooltip>
      {!isPublicationMode && !shouldHideMenu && (
        <SwimlaneHeaderMenu
          onOpenCard={onOpenCard}
          hideHeader={hideHeader}
          openCardLabel={openCardLabel}
          Icon={MoreHoriz}
          hideHeaderTooltip={hideHeaderTooltip}
          reorderDisabledTooltip={reorderDisabledTooltip}
          isReOrderingDisabled={isReOrderingDisabled}
          isViewCardOptionDisabled={isViewCardOptionDisabled}
          isHeaderMenuDisabled={isHeaderMenuDisabled}
          level={1}
          buttonSize={COLUMN_HEADER_HEIGHT.value}
        />
      )}
    </ColumnHeaderCell>
  );
}

const ColumnHeaderText = styled('span')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.75rem',
  lineHeight: '1.25',
  fontWeight: 700,
  letterSpacing: '0.025em',
  textTransform: 'uppercase',
  width: '100%',
  textAlign: 'center',
});

const ColumnHeaderCell = styled(HeaderCell)({
  height: COLUMN_HEADER_HEIGHT.label,
  justifyContent: 'space-between',
  padding: '0 12px',
  top: '0',
  width: '100%',
  display: 'flex',
  borderRadius: '8px',
});
